<template>
  <!-- 联系我们 -->
  <div
    class="contactUs"
    :style="{
      opacity: showContact == 2 ? 1 : 0,
      pointerEvents: showContact == 2 ? 'all' : 'none'
    }"
  >
    <!-- 内容文字 -->
    <div class="contactText">
      <img
        class="contact_img"
        src="../assets/images/logo/feiyin-contact.png"
        alt=""
      />
      <div class="feiyin-name">
        <p>上海费隐广告有限公司</p>
        <p class="en">ShangHai FEIYIN Advertising Co.,Ltd.</p>
      </div>
      <p class="contact-mail">
        <a href="mailto:info@feiyin-sh.cn">
          <img src="../assets/images/logo/mail.png" alt="" />
          <span>info@feiyin-sh.cn</span></a
        >
      </p>
      <a
        href="http://api.map.baidu.com/geocoder?address=上海市静安区安远路1号405室&output=html&src=webapp.baidu.openAPIdemo"
        target="_blank"
        class="contact-address"
      >
        <img src="../assets/images/logo/address.png" alt="" />
        <div class="addressText">
          <p>上海市静安区安远路1号405室</p>
          <p class="en">
            Room 405,No.1 Anyuan Road, Jing'an District,<br />
            Shanghai,China,200041
          </p>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import { Bus } from "../bus";
export default {
  data() {
    return {
      liLight: 0,
      showContact: 0
    };
  },
  created() {
    // 判断联系我们内容是否显示，总线获取liActiveNum，从AboutUs获取
    Bus.$on("liActiveNum", liActiveNum => {
      this.showContact = liActiveNum;
    });
  }
};
</script>

<style>
.contactUs {
  position: absolute;
  top: 15.5rem;
  right: 0;
  width: 88%;
  height: 40%;
  z-index: 9;
  -webkit-transition: 1s linear;
  transition: 1s linear;
}
.contactUs a {
  text-decoration: none;
  color: #fff;
}
.contactUs .feiyin-name {
  opacity: 0.5;
}
.contactUs .feiyin-name .en {
  margin-top: 10px;
}
.contactUs .contactText {
  width: 50%;
  height: 60%;
  position: absolute;
  left: 50%;

  display: -webkit-box;

  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  -webkit-box-pack: justify;
  justify-content: space-between;
  -webkit-box-align: normal;
  align-items: normal;
  letter-spacing: 1px;
}
.contactUs .contact_img {
  width: 40%;
}
.contactUs {
  font-size: 1.1rem;
}
.contactUs p {
  margin: 0;
  padding: 0;
}
.contactUs a {
  display: -webkit-box;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
}
.contactUs .contact-mail {
  opacity: 0.5;
}
.contactUs .contact-mail:hover {
  opacity: 1;
}

.contactUs a.contact-address {
  display: -webkit-box;
  display: flex;
  -webkit-box-align: start;
  align-items: flex-start;
  opacity: 0.5;
}
.contactUs .contact-address:hover {
  opacity: 1;
}
.contactUs a img {
  width: 5%;
}
.contactUs .addressText {
  margin-left: 10px;
}
.contactUs .addressText .en {
  margin-top: 10px;
}
.contactUs .contact-mail span {
  margin-left: 10px;
}
</style>
